import { Component, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatMenuModule } from "@angular/material/menu";
import { MatDividerModule } from "@angular/material/divider";
import { RouterModule } from "@angular/router";
import { AuthService } from "../../services/auth.service";
import { Router } from "@angular/router";
@Component({
	selector: "app-header",
	standalone: true,
	imports: [
		CommonModule,
		MatToolbarModule,
		MatIconModule,
		MatButtonModule,
		MatMenuModule,
		MatDividerModule,
		RouterModule,
	],
	templateUrl: "./header.component.html",
	styleUrls: ["./header.component.scss"],
})
export class HeaderComponent {
	private authService = inject(AuthService);
	private router = inject(Router);

	user$ = this.authService.userDoc$;

	async logout(): Promise<void> {
		try {
			await this.authService.logout();
		} catch (error) {
			console.error("Logout failed:", error);
		}
	}

	async navigateTo(path: string): Promise<void> {
		// Check session validity before navigation
		const isValid = await this.authService.checkSessionBeforeNavigation();
		if (isValid) {
			void this.router.navigate([path]);
		}
		// If invalid, the auth service will handle logout and show message
	}

	onImageError(event: Event): void {
		const imgElement = event.target as HTMLImageElement;
		// Set to default avatar on error
		imgElement.src = "/default-avatar.webp";
	}
}
